import React from 'react'
import { ThemeProvider } from 'styled-components'
import Icon from '../icon/icon.component'
import * as Styles from './button.styles'

type Props = {
  disabled?: boolean
  onClick?: any
  icon?: string
  primary?: boolean
  text: string
  type?: 'button' | 'submit'
}

const Button: React.FC<Props> = (props: Props): JSX.Element => {
  const renderIcon = (): JSX.Element => <Icon icon={props.icon} />

  return (
    <ThemeProvider
      theme={props.primary ? Styles.themes.primary : Styles.themes.default}
    >
      <Styles.Button
        onClick={props.onClick}
        disabled={props.disabled}
        startIcon={props.icon && renderIcon()}
      >
        {props.text}
      </Styles.Button>
    </ThemeProvider>
  )
}

Button.defaultProps = {
  type: 'button'
}

export default Button
